import { Dictionary } from "../../../common/utils/types";

import React from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";

interface BasicMenuProps {
    options: Dictionary<() => void>;
    disabled?: boolean;
}

const BasicMenu: React.FC<BasicMenuProps> = ({ options, disabled }) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(null);
    };

    return (
        <div>
            <IconButton
                aria-label="more"
                aria-controls={open ? "basic-menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                aria-haspopup="true"
                onClick={handleClick}
                onMouseDown={(e) => e.stopPropagation()}
                disabled={disabled || Object.keys(options).length === 0}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                onMouseDown={(e) => e.stopPropagation()}
            >
                {Object.entries(options).map(([key, value]) => (
                    <MenuItem
                        key={key}
                        onClick={(e) => {
                            value();
                            handleClose(e);
                        }}
                    >
                        {key}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
};

export default BasicMenu;
